import {usePage} from "@inertiajs/vue3";
import Cookies from "js-cookie";

const Auth = {
  /**
   * @param {PrivacyVault} privacy
   * @param redirectUrl
   */
  logout(privacy, redirectUrl = null) {
    const page = usePage();
    const url = redirectUrl ?? page.props.links.p4u + "/medicheck-logout";

    // this is required for dev, because the target site will not be able to clear the cookies
    Cookies.remove("mc_token", {path: "/"});

    if (redirectUrl !== null) {
      // when manually redirecting to a redirectUrl, we have to force delete
      // the cookie; therefore we need the correct cookie domain
      const hostname = globalThis.location.hostname; // e.g. "data.vorschau-medicheck.pharma4u.dev"
      const parts = hostname.split(".");
      if (parts.length >= 2) {
        const domain = "." + parts.slice(-2).join("."); // → ".pharma4u.dev"
        Cookies.remove("mc_token", {path: "/", domain: domain});
      } else {
        console.error("Could no remove cookie due to unknown domain.");
      }
    }

    privacy.purgeLocalStorage();

    globalThis.location.href = url;
  },
};

export default Auth;
